import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { IConfirmationDialog } from "../../interfaces";

export const DeleteDraftDialog: React.FC<IConfirmationDialog> = ({
    open,
    handleClose,
    ...props
}: IConfirmationDialog) => {

    return <Dialog
        open={open}
        maxWidth="xs"
        fullWidth={true}
        onClose={handleClose}
    >
        <DialogTitle>Delete Draft?</DialogTitle>

        <DialogContent>
            <DialogContentText>
                You can not recover a draft that has been deleted.
            </DialogContentText>
        </DialogContent>

        <DialogActions>
            <Button color="warning" onClick={() => handleClose(false)}>Cancel</Button>
            <Button color="error" onClick={() => handleClose(true)}>Delete</Button>
        </DialogActions>
    </Dialog>
}